import { EmployeeStatus, StatusTagData } from './types';

export const STATUS_MAP: Record<EmployeeStatus, StatusTagData> = {
    active: { variant: 'green', text: 'Активен' },
    disabled: { variant: 'red', text: 'Заблокирован' },
};
